/**
 * @fileoverview POSTWS handler for the "/engagement/async/campaign_preview/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { engagementAsyncCampaignPreviewAppGroupId } from "./constants";
import type {
  PostwsEngagementAsyncCampaignPreviewAppGroupIdPayload,
  PostwsEngagementAsyncCampaignPreviewAppGroupIdProps,
} from "./types";
import { isEngagementAsyncCampaignPreviewAppGroupIdResult } from "./validators";

export const postwsEngagementAsyncCampaignPreviewAppGroupId = reactQueryPostWebsocketAdapter(
  engagementAsyncCampaignPreviewAppGroupId,
  async (
    signal,
    {
      timeout = 180000,
      jobToken,
      estimated,
      forceRefresh,
      ...props
    }: PostwsEngagementAsyncCampaignPreviewAppGroupIdProps
  ): Promise<{}> => {
    const payload: PostwsEngagementAsyncCampaignPreviewAppGroupIdPayload = {
      campaign_id: props.campaignId,
      timeout,
      job_token: jobToken,
      estimated,
    };

    return fetch(`/engagement/async/campaign_preview/${props.appGroupId}`, "POST", payload, {
      signal,
      headers: { "Force-Cache-Refresh": forceRefresh },
    });
  },
  isEngagementAsyncCampaignPreviewAppGroupIdResult
);
